import { Box, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import 'leaflet/dist/leaflet.css';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import BarLine from '../components/bar_line';
import MapBsnTelAverage from '../components/map_bsn_tel_average';
import MapRiskMax from '../components/map_risk_rain';
import VerticalBar from '../components/vertical_bar';
import HeatmapRisk from '../components/heatmap_risk';
import MapShelterAnalysis from '../components/map_shelter_analysis';
import ScatterRisk from '../components/scatter_risk';
import VerticalBarStack from '../components/vertical_bar_stack';
import { SR_Y_4LINES } from '../const/annotations';
import { GRID_RANK } from '../const/grid';
import { BASE_LAYER_LIST } from '../const/map_config';
import { RISK_HEATMAP_COLOR, RISK_LEVEL_POINT, SOIL_RISK_COLOR, SR_RISK_LEVEL_POINT } from '../const/color';
import { useDataFromS3 } from '../hooks/useDataFromS3';
import {
    setChronologyLevelColor,
    setSrRiskColor,
    setTelRiskColor,
    setSrColor,
    setSrRiskLabel,
    setSrFontSize,
    setRoadRiskColor
} from '../func/color';
import CommonCard from '../item/common_card';
import MaxRiskH1Txt from '../item/max_risk_h1_txt';
import Proggress from '../item/progress';
import DamageIncidents from '../item/damage_incidents_txt';
import '../style/legend_risk.css';
import {
    convertAreaDataFromMshData,
    convertCityDataFromMshData,
    getAllByCityCode,
    getAllByCode,
    getAllByDateTimeWithAreaRiskInfo,
    getAllByShelterCode,
    getChronologyRankWithLimit,
    getCityCodeByShelterCode,
    getKeyNameCountByDateTime,
    getMaxByDateTime,
    getMaxH1OfByCode,
    getRiskH1MaxByCode,
    getRankWithLimit,
    getShelterAnalysisList,
    getShelterCodeByCityCode,
    getTelTimeAry,
    getAllByDateTimeWithAreaRisk,
    convertCityDataRiskFromMshData,
    getAllByDateTimeCityInfo,
    getAllByMshCodeChronology,
    getTelIsCurrentVal,
    getMaxListTel,
    getRankBsn,
    convertRoadDataFromMshData,
    getTimeAry,
    convertAreaDataMshData,
    filterDataByCodeAry,
    convertAreaDataSrRainFromMshData,
    convertAreaDataScatterFromAreaData,
    convertAreaDataScatterFromMshData,
    convertCityDataScatterFromAreaData
} from '../func/util';
import { getSrRiskLevel } from '../func/risk_analysis_utils'
import choropleth_area from '../data/area.json';
import choropleth_bsn from '../data/bsn.json';
import choropleth_city from '../data/city.json';
import choropleth_msh from '../data/msh.json';
import choropleth_tel from '../data/tel.json';
import PageLayout from '../item/page_layout';

const Summary = (props) => {
    // 期間最大警報基準相当
    const [landslideRiskMaxVal, setLandslideRiskMaxVal] = useState(null);
    // 期間最大1時間雨量
    const [landslideH1MaxVal, setLandslideH1MaxVal] = useState(null);
    // 選択中のレイヤー（市町村、字、メッシュ、クロノロジーのどれを表示しているか）
    const [selectLayer, setSelectLayer] = useState(
        BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1]
    );
    // 市町村、字、メッシュ、個別の選択をクリアするかしないかのフラグ
    const [shouldClearSelect, setShouldClearSelect] = useState(false)
    // 市町村レイヤー
    const [cityLandslideRiskH1, setCityLandslideRiskH1] = useState(null);
    // 字レイヤー
    const [areaLandslideRiskH1, setAreaLandslideRiskH1] = useState(null);
    // メッシュレイヤー
    const [mshLandslideRiskH1, setMshLandslideRiskH1] = useState(null);
    // クロノロジーレイヤー
    const [selectLayerList, setSelectLayerList] = useState({ chronology: true });
    // 字名ごとの1時間雨量, 土壌雨量指数
    const [riskScatterAllDatetimeArea, setRiskScatterAllDatetimeArea] = useState(null);
    // 市町村ごとの1時間雨量, 土壌雨量指数
    const [riskScatterAllDatetimeCity, setRiskScatterAllDatetimeCity] = useState(null);
    // 期間内1時間雨量, 土壌雨量指数
    const [landslideMaxRiskDatetime, setLandslideMaxRiskDatetime] = useState(null);
    const [landslideMaxH1Datetime, setLandslideMaxH1Datetime] = useState(null);
    const [soilRainMaxRiskDatetime, setSoilRainMaxRiskDatetime] = useState(null);
    const [soilRainMaxLvDatetime, setSoilRainMaxLvDatetime] = useState(null);
    const [soilRainMaxH1Datetime, setSoilRainMaxH1Datetime] = useState(null);
    const [barOrLineAnnotatios, setBarOrLineAnnotatios] = useState(null);
    const [barOrLineLimitVal, setBarOrLineLimitVal] = useState(null);
    // 市町村名, 日時ごとの警報基準相当
    const [tooltipInfoScatterRisk, setTooltipInfoScatterRisk] = useState(null);
    const [landslideAllRiskDatetime, setLandslideAllRiskDatetime] = useState(null);
    // クロノロジー発生件数
    const [mainDamageVal, setMainDamageVal] = useState(null);
    // 対処済件数
    const [finishVal, setFinishVal] = useState(null);
    // 対処中件数
    const [ongoingVal, setOngoingVal] = useState(null);
    // クロノロジー分析
    const [chronologyCityData, setChronologyCityData] = useState(null);
    const [chronologyList, setChronologyList] = useState(null);
    // 河川水位計と流出量変化
    const [bsnH1Of, setBsnH1Of] = useState(null);
    const [telDataLatestVal, setTelDataLatestVal] = useState(null);
    // 水位パーセントランキング
    const [telRiskAllRankData, setTelRiskAllRankData] = useState([]);
    // 道路リスクランキング
    const [roadAllRankData, setRoadAllRankData] = useState(null);
    // 避難所と避難指示発令地域
    const [shelterAnalysisData, setShelterAnalysisData] = useState(null);
    const [evacLevelCityData, setEvacLevelCityData] = useState(null);

    const [dateArray, setDateArray] = useState(null);
    const [shouldFetch, setShouldFetch] = useState(false);
    const [shouldFetchTel, setShouldFetchTel] = useState(false);

    const location = useLocation();
    const prevDatetimeRef = useRef(null);
    const prevTelDatetimeRef = useRef(null);

    // 全データ再取得の要否を定期監視する
    const {
        data: datetimeLatest,
        loading: datetimeLatestLoading,
        error: datetimeLatestError,
    } = useDataFromS3(`api/get_datetime_latest`);

    // 10分おきの水位計の時刻を取得
    const {
        data: telDatetimeLatest,
    } = useDataFromS3(`api/get_tel_datetime_latest`);

    // サーバーの最終更新日時が変更されているか判定
    useEffect(() => {
        if (datetimeLatest && JSON.stringify(datetimeLatest) !== JSON.stringify(prevDatetimeRef.current)) {
            prevDatetimeRef.current = datetimeLatest;
            setShouldFetch(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetch(false); // dataが変わってないならメインデータを取得しない
        }
    }, [datetimeLatest]);

    useEffect(() => {
        if (telDatetimeLatest && JSON.stringify(telDatetimeLatest) !== JSON.stringify(prevTelDatetimeRef.current)) {
            prevTelDatetimeRef.current = telDatetimeLatest;
            setShouldFetchTel(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetchTel(false); // dataが変わってないならメインデータを取得しない
        }
    }, [telDatetimeLatest]);

    let tel_url = null
    let bsn_of_url = null
    let road_risk_url = null
    let landslide_msh_url = null
    let msh_chronology_url = null
    let bsn_url = null
    let shelter_url = null
    let shelter_evac_level_city_url = null
    let risk_status_url = null

    if (shouldFetch) {
        landslide_msh_url = `api/get_risk`;
        msh_chronology_url = `api/get_chr_analized`;
        road_risk_url = `api/get_risk_road`;
        bsn_of_url = `api/get_bsn_of`;
        shelter_url = `api/get_shelter_analysis_dtl`;
        shelter_evac_level_city_url = `api/get_shelter_analysis_evac_level_city`;
        bsn_url = `api/get_bsn_flood_impact`;
        risk_status_url = `api/get_risk_status`;
    }

    if (shouldFetchTel) {
        tel_url = `api/get_tel_mtr`
    }

    // 土砂災害リスクを取得
    const {
        data: mshLandslideData,
        loading: mshLandslideLoading,
        error: mshLandslideError,
    } = useDataFromS3(landslide_msh_url);

    // クロノロジーデータを取得
    const {
        data: mshChronologyData,
        loading: mshChronologyLoading,
        error: mshChronologyError,
    } = useDataFromS3(msh_chronology_url);

    // 水位計データを取得
    const {
        data: telData,
        loading: telLoading,
        error: telError,
    } = useDataFromS3(tel_url);

    // 流域平均流出量を取得
    const {
        data: bsnOfData,
        loading: bsnOfLoading,
        error: bsnOfError,
    } = useDataFromS3(bsn_of_url);

    // 避難所分析データを取得
    const {
        data: shelterData,
        loading: shelterLoading,
        error: shelterError,
    } = useDataFromS3(shelter_url);

    // 避難所分析の避難指示発令地域データを取得
    const {
        data: shelterEvacLevelCityData,
        loading: shelterEvacLevelCityLoading,
        error: shelterEvacLevelCityError,
    } = useDataFromS3(shelter_evac_level_city_url);

    // 道路リスクを取得
    const {
        data: roadRiskData,
        loading: roadRiskLoading,
        error: roadRiskError,
    } = useDataFromS3(road_risk_url);

    // 災害情報を取得
    const {
        data: riskStatusData,
        loading: riskStatusLoading,
        error: riskStatusError
    } = useDataFromS3(risk_status_url);

    useEffect(() => {
        prevDatetimeRef.current = null
        prevTelDatetimeRef.current = null
    }, [location.pathname])

    // 散布図クリック時の動作
    const scatterClickEvent = (series, seriesIndex, point) => {
        props.setRiskMapCenter(series[seriesIndex].arealng, series[seriesIndex].arealat)
        setShouldClearSelect(false)
        setSelectLayer(BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1])
        props.setSelectMsh([]);
        if (point?.meta.type === "area") {
            props.setSelectSubCity([]);
            props.setSelectArea([point?.meta.area_code[0]]);
        }
        if (point?.meta.type === "city") {
            props.setSelectSubCity([point?.meta.city_code]);
            props.setSelectArea([]);
        }
    }

    // 複合グラフのマーカー情報
    const getPoints = (date_ary, data_x, data_x2) => {
        let points = []
        for (let i = 0; i < data_x.length; i++) {
            const color = setSrColor(SR_RISK_LEVEL_POINT, data_x2[i]);

            const point = {
                x: date_ary[i],
                y: data_x[i],
                marker: {
                    size: 4,
                    fillColor: color,
                    strokeColors: 'transparent',
                    strokeWidth: 0,
                    shape: "circle",
                },
            }
            points.push(point)
        }
        return points
    }

    // 複合グラフの折れ線チャートの基準線を取得
    const getConsts = (func, POINT) => {
        const limitVal = (POINT && (POINT.LEVEL_5 ?? POINT.LEVEL_4 ?? POINT.LEVEL_3 ?? POINT.LEVEL_2 ?? POINT.LEVEL_1)) ?? 2000;
        return {
            point: POINT,
            bar_or_line_annotations: func(POINT),
            bar_or_line_limit_val: limitVal
        };
    }

    // ヒートマップの数値表示変換処理
    const format = (val) => parseFloat(val).toFixed(0);

    // ヒートマップのカラー
    const colorScaleRisk = () => {
        return {
            ranges: RISK_HEATMAP_COLOR
        }
    }

    // 警報基準相当マップの色設定
    const setMapRiskColor = (POINT, risk) => {
        return POINT[`LEVEL_${risk}`]?.color || POINT.LEVEL_1.color;
    };

    // Extracts 1-hour rainfall values (Y-axis) from scatter data
    const soil_rain_h1_ary = (scatterData) => {
        return scatterData.map((obj) => obj.h1_h24_val[0]);
    }

    // Extracts 24-hour rainfall values (X-axis) from scatter data
    const soil_rain_dc_tank_ary = (scatterData) => {
        return scatterData.map((obj) => obj.h1_dc_tank_of_val[1]);
    }

    /**
     * Builds city-level scatter series (H1 vs DC Tank)
     * - Adds dynamic marker size by risk level
     *
     * @param {Array} chartData
     * @param {boolean} isSlider
     * @param {Array} value
     * @returns {Array}
     */
    const soilRainGetSeriesH1DcTank = (chartData, isSlider, value) => {
        if (!chartData?.length) return [];
        const filteredData = isSlider ? chartData.slice(value[0], value[1] + 1) : chartData;
        const colorGroups = {};
        filteredData.forEach(item => {
            const [y, x] = item.h1_dc_tank_of_val;
            const color = setSrRiskColor(item?.soil_index_level).color;

            if (!colorGroups[color]) {
                colorGroups[color] = {
                    name: item.name,
                    data: [],
                    color: color,
                };
            }

            colorGroups[color].data.push({
                x, y,
                meta: {
                    name: item.name,
                    data: [[x, y]],
                    city_name: item.city_name,
                    area_code: item.area_code,
                    arealng: item.area_lng,
                    arealat: item.area_lat,
                    soil_index_level: item.soil_index_level,
                    h1_dc_tank_of_val: item.h1_dc_tank_of_val,
                    type: "area"
                }
            });
        });
        return Object.values(colorGroups);
    };

    const renderTooltipBody = (tooltipKey, tooltipInfo) => {
        if (!tooltipInfo?.data) return null;
        const d = tooltipInfo.data;
        switch (tooltipKey) {
            case 'scatter_rain_h1_dc_tank':
                return (<>
                    <InfoRow label="土壌雨量指数" value={d.h1_dc_tank_of_val?.[1]} />
                    <InfoRow label="1時間雨量" value={d.h1_dc_tank_of_val?.[0]} />
                    <InfoRow label="警戒基準相当" value={d.soil_index_level} />
                    <InfoRow label="しきい値" value={"警報基準相当"} />
                    <InfoRow label="しきい値名" value={"新規しきい値"} />
                    <InfoRow label="範囲" value={getLabelTooltipSoilLevel(d.soil_index_level)} />
                </>
                );

            case 'scatter_rain_h1_h24':
                return (<>
                    <InfoRow label="24時間雨量" value={d.h1_h24_val?.[1]} />
                    <InfoRow label="1時間雨量" value={d.h1_h24_val?.[0]} />
                    <InfoRow label="警戒基準相当" value={d.soil_index_level} />
                    <InfoRow label="しきい値" value={"警報基準相当"} />
                    <InfoRow label="しきい値名" value={"新規しきい値"} />
                    <InfoRow label="範囲" value={getLabelTooltipSoilLevel(d.soil_index_level)} />
                </>
                );
            case 'scatter_rain_h1_dc_tank_city':
                return (<>
                    <InfoRow label="土壌雨量指数" value={d.h1_dc_tank_of_val[1]} />
                    <InfoRow label="1時間雨量" value={d.h1_dc_tank_of_val[0]} />
                    <InfoRow label="土砂災害発生リスク" value={d.risk_val} />
                    <InfoRow label="警報基準相当" value={d.soil_index_level} />
                    <InfoRow label="しきい値" value={"警報基準相当"} />
                    <InfoRow label="しきい値名" value={"新規しきい値"} />
                    <InfoRow label="範囲" value={getLabelTooltipSoilLevel(d.soil_index_level)} />
                </>
                )
            case 'heatmap_rain_city':
                return (<>
                    <InfoRow label="日時" value={d.x} />
                    <InfoRow label="市町村名" value={d.city_name} />
                    <InfoRow label="しきい値" value={"警報基準相当"} />
                    <InfoRow label="しきい値名" value={"新規しきい値"} />
                    <InfoRow label="範囲" value={getLabelTooltipSoilLevel(d.soil_index_level)} />
                </>
                );

            default:
                return null;
        }
    };

    const InfoRow = ({ label, value }) => (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography fontSize={13}>{label}</Typography>
            <Typography fontSize={13} fontWeight="bold">{value}</Typography>
        </Box>
    );

    /**
     * Returns display label for soil risk level
     * @param {number} level - soil risk level value
     * @returns {string} label text for tooltip
     */
    const getLabelTooltipSoilLevel = (level) => {
        const key = `LEVEL_${level}`;
        return SOIL_RISK_COLOR[key]?.label ?? '';
    };

    /**
     * Builds city-level scatter series (H1 vs DC Tank of City)
     * - Adds dynamic marker size by risk level
     *
     * @param {Array} chartData
     * @param {boolean} isSlider
     * @param {Array} value
     * @returns {Array}
     */
    const soilRainGetSeriesH1DcTankCity = (chartData, isSlider, value) => {
        if (!chartData?.length) return [];
        const filteredData = isSlider ? chartData.slice(value[0], value[1] + 1) : chartData;
        const groups = {};
        filteredData.forEach(item => {
            const [y, x] = item.h1_dc_tank_of_val;
            const color = setSrRiskColor(item?.soil_index_level)?.color;
            const sizePoint = setSrRiskColor(item?.soil_index_level)?.size_point;
            const key = item.city_code ?? item.name; // group by city_code (fallback to name)
            if (!groups[key]) {
                groups[key] = {
                    name: item.name,
                    data: [],
                    color: color,
                    marker: {
                        size: sizePoint
                    }
                };
            }

            groups[key].data.push({
                x, y,
                meta: {
                    name: item.name,
                    area_lat: item.area_lat,
                    area_lng: item.area_lng,
                    city_code: item.city_code,
                    city_name: item.city_name,
                    soil_index_level: item.soil_index_level,
                    h1_dc_tank_of_val: item.h1_dc_tank_of_val,
                    risk_val: item.risk_val,
                    type: "city"
                }
            });
        });
        return Object.values(groups);
    };

    // 複合グラフのカラー（1時間雨量）
    const getBarColorH1Rain = (value, series, seriesIndex, dataPointIndex, w) => {
        // 上に表示している土壌雨量指数の点（getPoints）と同じ色にする
        return w.config.annotations.points[dataPointIndex].marker.fillColor
    }

    // ツールチップのマーカーも土壌雨量指数の色にする
    const getTooltipMarkerColorSoilRain = (dataPointIndex, w) => {
        return w.config.annotations.points[dataPointIndex].marker.fillColor
    }

    const getHeatmapRiskData = (date_ary, area_val_ary, isOver) => {
        let sorted_ary = []
        if (area_val_ary?.length > 1) {
            sorted_ary = [...area_val_ary].sort((a, b) => (b.city_code - a.city_code));
        } else {
            sorted_ary = area_val_ary
        }
        const chartData = sorted_ary.map((item) => ({
            name: item?.city_name,
            data: item?.risk_val.map((val, i) => ({
                x: date_ary[i],
                y: val === 0 ? 0.0001 : val,
                value: val,
                name: val,
                soil_index_level: val,
                city_code: item?.city_code,
                city_name: item?.city_name,
                area_lat: item?.area_lat,
                area_lng: item?.area_lng
            }))
        }));
        return chartData;
    }

    /**
     * Handles click event on heatmap cell
     * - Centers map to selected city
     * - Resets selection state
     * - Switches map layer to default
     *
     * @param {Object} clickedItem - clicked heatmap cell data
     */
    const heatmapClickEvent = (clickedItem) => {
        const cityCode = clickedItem.city_code;
        props.setBsnMapCenter([clickedItem.area_lng, clickedItem.area_lat])
        props.setRiskMapCenter([clickedItem.area_lng, clickedItem.area_lat])
        setShouldClearSelect(false)
        setSelectLayer(BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1])
        props.setSelectArea([])
        props.setSelectSubCity([cityCode]);
        props.setSelectMsh([]);
        props.setSelectBsn([]);
    }

    // ランキングデータ取得（クロノロジー分析ランキング）
    const getRankDataChronology = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.total !== b.total) {
                    return a.total - b.total;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => {
                if (a.total !== b.total) {
                    return b.total - a.total;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        }

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: rankData[i].total,
                        custom: {
                            city_name: rankData[i].city_name,
                            city_code: rankData[i].city_code,
                            area_lng: rankData[i].area_lng,
                            area_lat: rankData[i].area_lat,
                            total: rankData[i].total
                        }
                    })
                    category_ary.push(rankData[i].city_name)
                }
            }
        } else {
            data.map(item => {
                series_ary.push({
                    x: '',
                    y: item.total,
                    custom: {
                        city_name: item.city_name,
                        city_code: item.city_code,
                        area_lng: item.area_lng,
                        area_lat: item.area_lat,
                        total: item.total
                    }
                })
                category_ary.push(item.city_name)
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // ランキングクリック時の動作（クロノロジー分析ランキング）
    const verticalBarChronologyClickEvent = (clickedItem) => {
        props.setSelectSubCity([clickedItem.custom.city_code])
    }

    // ランキングのカラー（クロノロジー分析ランキング）
    const getRankColorChronology = (value, series, seriesIndex, dataPointIndex) => {
        return setChronologyLevelColor(series[seriesIndex].name)
    }

    const toZenkakuAll = (str) => {
        return str
            .replace(/[0-9A-Za-z]/g, s => String.fromCharCode(s.charCodeAt(0) + 0xFEE0)) // 半角英数字 → 全角
            .replace(/,/g, '、')         // 半角カンマ → 全角カンマ
            .replace(/ /g, '　')         // 半角スペース → 全角スペース
            .replace(/\(/g, '（')        // 半角( → 全角（
            .replace(/\)/g, '）');       // 半角) → 全角）
    };

    // ランキングのラベルフォーマット
    const getLabelFormat = (value) => {
        const str = toZenkakuAll(String(value));
        // 8文字以上は右側を省略
        if (str.length >= 8) {
            return str.slice(0, 7) + '...';
        }
        return '　'.repeat(8 - str.length) + str;
    }


    // ランキングのラベルフォーマット（クロノロジー分析ランキング）
    const getChrLabelFormat = (value) => {
        let str = String(value);
        return '　'.repeat(Math.max(0, 5 - str.length)) + str;
    }

    // ランキングのX軸ツールチップフォーマット
    const tooltipFormatX = (opts) => {
        return '';
    }

    // ランキングのX軸ツールチップフォーマット（水位パーセントランキング）
    const tooltipFormatXRiver = (opts) => {
        return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].custom.txt_river_name;
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatY = (val) => {
        return String(val);
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatCustom = (opts, areaNameAry, areaRiverNameAry) => {
        const value = opts.series[opts.seriesIndex][opts.dataPointIndex]; // 値
        const seriesName = opts.w.globals.seriesNames[opts.seriesIndex];

        return `<div style="padding: 4px 8px; font-size: 12px;">
                ${seriesName}: ${value}
                </div>`;
    }

    // ランキングのY軸ツールチップフォーマット（水位パーセントランキング）
    const tooltipFormatCustomRiver = (opts, areaNameAry, areaRiverNameAry) => {
        const value = opts.series[opts.seriesIndex][opts.dataPointIndex]; // 値
        const series = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]?.custom;
        const seriesName = series.txt_river_name ?? series.txt_road_name;
        return `<div style="padding: 4px 8px; font-size: 12px;">
                ${seriesName}: ${value?.toLocaleString()}
                </div>`;
    }

    // ランキングクリック時の動作（水位パーセントランキング）
    const verticalBarClickEventRiver = (clickedItem) => {
        props.setSelectTelCode([clickedItem.custom.tel_code])
        props.setSelectMsh([clickedItem.custom.msh_code])
    }

    // ランキングのカラー（水位パーセントランキング）
    const getRankColorRiver = (value, series, seriesIndex, dataPointIndex, w) => {
        return setTelRiskColor(series[seriesIndex].data[dataPointIndex]?.custom.tel_risk)
    }

    // ランキングのフォーマット（水位パーセントランキング）
    const getFormatRiver = (val, opts) => {
        const customData = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]?.custom;
        return customData?.labelValue ?? '';
    }

    // ランキングデータ取得（水位パーセントランキング）
    const getRankDataRiver = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.risk_val === b.risk_val) {
                    return a.pct_val - b.pct_val;
                }
                return a.risk_val - b.risk_val
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => b.risk_val - a.risk_val)
            rankData.sort((a, b) => {
                if (a.risk_val === b.risk_val) {
                    return b.pct_val - a.pct_val;
                }
                return b.risk_val - a.risk_val
            })
        }

        // tooltip用
        const tempAreaNameAry = [];
        const tempAreaRiverNameAry = [];

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: getYValue(rankData[i].pct_val),
                        custom: {
                            name: rankData[i].name,
                            msh_code: rankData[i].msh_code,
                            txt_river_name: rankData[i].txt_river_name,
                            tel_code: rankData[i].code,
                            area_lng: rankData[i].lng,
                            area_lat: rankData[i].lat,
                            tel_risk: rankData[i].risk_val,
                            labelValue: getLabelValue(rankData[i].pct_val)
                        }
                    })
                    category_ary.push(`${rankData[i].name}（${rankData[i].txt_river_name}）`);
                    tempAreaNameAry.push(rankData[i].name);
                    tempAreaRiverNameAry.push(rankData[i].txt_river_name);
                }
            }
        } else {
            rankData.map(item => {
                series_ary.push({
                    x: '',
                    y: getYValue(item.pct_val),
                    custom: {
                        name: item.name,
                        msh_code: item.msh_code,
                        txt_river_name: item.txt_river_name,
                        tel_code: item.code,
                        area_lng: item.lng,
                        area_lat: item.lat,
                        tel_risk: item.risk_val,
                        labelValue: getLabelValue(item.pct_val)
                    }
                })
                category_ary.push(`${item.name}（${item.txt_river_name}）`);
                tempAreaNameAry.push(item.name);
                tempAreaRiverNameAry.push(item.txt_river_name);
            })
        }
        return { rankData, series_ary, category_ary, tempAreaNameAry, tempAreaRiverNameAry };
    }

    // ランキングクリック時の動作（道路リスクランキング）
    const verticalBarClickEventRoad = (clickedItem) => {
        props.setSelectMsh([clickedItem.custom.msh_code])
    }

    // ランキングのフォーマット（道路リスクランキング）
    const getFormatRoad = (val, opts) => {
        return `${val.toLocaleString()}`;
    }

    // ランキングのカラー（道路リスクランキング）
    const getRankColorRoad = (value, series, seriesIndex, dataPointIndex, w) => {
        return setRoadRiskColor(series[seriesIndex].data[dataPointIndex]?.custom.max)
    }

    // ランキングデータ取得（道路リスクランキング）
    const getRankDataRoad = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.max === b.max) {
                    return a.city_code - b.city_code;
                }
                return a.max - b.max
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => b.max - a.max)
            rankData.sort((a, b) => {
                if (a.max === b.max) {
                    return b.city_code - a.city_code;
                }
                return b.max - a.max
            })
        }
        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: rankData[i].max,
                        custom: {
                            msh_code: rankData[i].msh_code,
                            city_code: rankData[i].city_code,
                            city_name: rankData[i].city_name,
                            area_lng: rankData[i].area_lng,
                            area_lat: rankData[i].area_lat,
                            txt_road_name: rankData[i].txt_road_name,
                            max: rankData[i].max,
                        }
                    })
                    category_ary.push(`${rankData[i].city_name}${rankData[i].txt_road_name}`)
                }
            }
        } else {
            rankData.map(item => {
                series_ary.push({
                    x: '',
                    y: item.max,
                    custom: {
                        msh_code: item.msh_code,
                        city_code: item.city_code,
                        city_name: item.city_name,
                        area_lng: item.area_lng,
                        area_lat: item.area_lat,
                        txt_road_name: item.txt_road_name,
                        max: item.max,
                    }
                })
                category_ary.push(`${item.city_name}${item.txt_road_name}`)
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // データ整備用のパラメータを取得
    const getParams = (keyAry, keyName = '') => {
        const features_area = choropleth_area.features;
        const features_msh = choropleth_msh.features;
        const features_tel = choropleth_tel.features;
        const features_bsn = choropleth_bsn.features;
        const features_city = choropleth_city.features;

        let masterBsnFeatures = []
        let masterTelFeatures = []
        let tel_code_ary = []
        let bsn_code_ary = []
        let shelter_code_ary = []

        // --- 既存の tel_code 条件ロジック ---
        if (keyName === 'tel_code') {
            tel_code_ary = keyAry;
            masterTelFeatures = features_tel.filter(f =>
                tel_code_ary.includes(f.properties['tel_code'])
            );
            bsn_code_ary = [...new Set(masterTelFeatures.map(feature => feature.properties?.bsn_code))];
            masterBsnFeatures = features_bsn.filter(f =>
                bsn_code_ary.includes(f.properties['bsn_code'])
            );

            keyAry = props.selectMsh
            keyName = 'id'
        } else if (keyName === 'bsn_code') {
            bsn_code_ary = keyAry;
            masterBsnFeatures = features_bsn.filter(f =>
                bsn_code_ary.includes(f.properties['bsn_code'])
            );
            masterTelFeatures = features_tel.filter(f =>
                bsn_code_ary.includes(f.properties['bsn_code'])
            );
            tel_code_ary = [...new Set(masterTelFeatures.map(feature => feature.properties?.tel_code))];

            //該当するメッシュコードの配列
            keyAry = [...new Set(masterTelFeatures.map(feature => feature.properties?.msh_code))];
            keyName = 'id'
        }
        else if (keyName === 'id' && props.selectMsh.length > 0) {
            // telデータ取得
            masterTelFeatures = features_tel.filter(f =>
                keyAry.includes(f.properties['msh_code'])
            );
            tel_code_ary = [...new Set(masterTelFeatures.map(feature => feature.properties?.tel_code))];

            // bsnデータの properties.bsn_code を配列で取得(これが対象のbsnコード)
            bsn_code_ary = [...new Set(masterTelFeatures.map(feature => feature.properties?.bsn_code))];
            masterBsnFeatures = features_bsn.filter(f =>
                bsn_code_ary.includes(f.properties['bsn_code'])
            );
        } else {
            // 水位パーセントランキングクリック時以外
            const keyString = keyAry.map(String);
            masterBsnFeatures = features_bsn.filter(f =>
                keyString.includes(f.properties['city_code']?.toString())
            );
            // telデータ取得
            masterTelFeatures = features_tel.filter(f =>
                keyString.includes(f.properties['city_code']?.toString())
            );

            // bsnデータの properties.bsn_code を配列で取得(これが対象のbsnコード)
            bsn_code_ary = [...new Set(masterBsnFeatures.map(feature => feature.properties.bsn_code))];
            // telデータの properties.id を配列で取得(これが対象のtelコード)
            tel_code_ary = [...new Set(masterTelFeatures.map(feature => feature.properties.tel_code))];
        }

        let city_ary = []
        let msh_code_ary = []
        if (keyName === 'shelter_code') {
            shelter_code_ary = props.selectShelterCode;
            city_ary = getCityCodeByShelterCode(shelterData, shelter_code_ary);
        }

        let geoCode = null;
        const stringKeyAry = keyAry.flat().map(k => String(k));
        const numericKeyAry = stringKeyAry.map(k => Number(k)); // city_code比較用

        // --- メッシュデータ取得 (ここを配列対応に修正) ---
        let allFilteredMsh = features_msh.filter(f => {
            if (keyName === 'shelter_code') {
                geoCode = f.properties['city_code'];
            } else {
                geoCode = f.properties[keyName];
            }

            // 新しいJSONの配列形式に対応
            if (Array.isArray(geoCode)) {
                if (keyName === 'shelter_code') {
                    return geoCode.some(c => city_ary.includes(c));
                }
                else {
                    return geoCode.some(c => numericKeyAry.includes(c));
                }
            }
            if (keyName === 'shelter_code') {
                return city_ary.includes(geoCode);
            } else {
                return numericKeyAry.includes(geoCode);
            }
        });

        let masterMshFeatures = [];
        let masterAreaFeatures = [];
        let area_code_ary = [];

        // 選択時と初期表示時の切り分け
        if (keyAry.length === 1 && allFilteredMsh.length > 0 && keyName !== 'city_code' && keyName !== 'shelter_code') {
            // 地図選択時：最初の1件に絞り込み、その中のarea_codeも最初の1つにする
            let selectedTargetCode = keyAry[0];

            if (keyName === 'id') {
                area_code_ary = [...new Set(
                    allFilteredMsh.flatMap(f => {
                        const code = f.properties.area_code;
                        if (Array.isArray(code)) return code;
                        if (code != null) return [code];
                        return [];
                    })
                )];
                // 字のマスターデータ取得
                masterAreaFeatures = features_area.filter(f =>
                    area_code_ary.includes(f.properties.id)
                );

                // メッシュの情報をベースに、area_code を「選択されたコード1つ」に書き換える
                masterMshFeatures = allFilteredMsh.map(msh => ({
                    ...msh,
                    properties: {
                        ...msh.properties,
                        area_code: [area_code_ary[0]]
                    }
                }));
            }
            else {
                // クリックされた字コードに該当するデータを取得
                masterAreaFeatures = features_area.filter(f =>
                    String(f.properties.id) === String(selectedTargetCode)
                );

                // メッシュの情報をベースに、area_code を「選択されたコード1つ」に書き換える
                masterMshFeatures = allFilteredMsh.map(msh => ({
                    ...msh,
                    properties: {
                        ...msh.properties,
                        area_code: [selectedTargetCode]
                    }
                }));
            }
        } else {
            // 初期表示時：全データをそのまま使用
            masterMshFeatures = allFilteredMsh;
            area_code_ary = [...new Set(allFilteredMsh.flatMap(f => f.properties.area_code))];
            // masterAreaFeatures: 複数選択時や初期表示でも参照できるように作成
            // keyAry が市コード（city_code）の場合は city_code を使ってフィルタ
            if (Array.isArray(keyAry) && keyAry.length > 0) {
                masterAreaFeatures = features_area.filter(f => {
                    const pid = f.properties && f.properties.id;
                    const pcity = f.properties && f.properties.city_code;
                    return (
                        (pid != null && (keyAry.includes(pid) || keyAry.includes(String(pid)))) ||
                        (pcity != null && (keyAry.includes(pcity) || keyAry.includes(String(pcity))))
                    );
                });
            } else {
                masterAreaFeatures = [];
            }
        }

        // --- メッシュコード配列取得 ---
        msh_code_ary = masterMshFeatures.map(feature => feature.properties.id);

        // --- city 用の配列とフィーチャーを作成 ---
        let city_code_ary = [];
        let masterCityFeatures = [];

        if (keyName === 'city_code') {
            // 指定された city_code を元に市町村ポリゴン（features_city から）を取得
            const targetCitySet = new Set(
                (keyAry || []).map(k => Number(k)).filter(n => !isNaN(n))
            );

            masterCityFeatures = features_city.filter(feature => {
                const raw = feature.properties.id;
                if (Array.isArray(raw)) {
                    return raw.some(r => targetCitySet.has(Number(r)));
                }
                return targetCitySet.has(Number(raw));
            });

            city_code_ary = masterCityFeatures
                .map(f => Number(f.properties.id))
                .filter((v, i, a) => !isNaN(v) && a.indexOf(v) === i);
        } else {
            // msh から導出される city_code を元に市町村フィーチャーを取得
            const citySet = new Set(
                masterMshFeatures
                    .map(f => f.properties.city_code)
                    .map(c => Number(c))
                    .filter(n => !isNaN(n))
            );

            city_code_ary = Array.from(citySet);
            if (city_code_ary.length > 0) {
                masterCityFeatures = features_city.filter(f => {
                    const raw = f.properties.id;
                    if (Array.isArray(raw)) {
                        return raw.some(r => city_code_ary.includes(Number(r)));
                    }
                    return city_code_ary.includes(Number(raw));
                });
            }
        }

        if (keyName === 'shelter_code') {
            shelter_code_ary = props.selectShelterCode;
            city_code_ary = getCityCodeByShelterCode(shelterData, shelter_code_ary);
        } else {
            shelter_code_ary = getShelterCodeByCityCode(shelterData, city_code_ary);
        }

        return {
            msh_code_ary, bsn_code_ary, tel_code_ary, city_code_ary, shelter_code_ary,
            masterMshFeatures, masterAreaFeatures, masterTelFeatures, masterCityFeatures
        };
    }

    useEffect(() => {
        // ローディング開始
        props.setReady(prev => {
            const updated = Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            );
            return updated;
        });
        const fetchData = async () => {
            let params_obj = {}
            let date_ary = []

            let msh_landslide_risk_h1_all_datetime = []
            let area_landslide_risk_h1_all_datetime = []
            let area_landslide_risk_h1_all_datetime_msh = []
            let city_sr_lv_all_datetime_msh = []
            let city_landslide_risk_h1_all_datetime = []
            let risk_scatter_all_datetime_area = []
            let risk_scatter_all_datetime_city = []

            let area_landslide_risk_h1_max = []
            let area_landslide_risk_all_datetime = []
            let city_landslide_risk_h1_max = []
            let msh_landslide_risk_h1_max = []

            let landslide_risk_rank = []
            let landslide_risk_maxVal = null
            let landslide_h1_maxVal = null
            let landslide_h1_max_datetime = []
            let landslide_risk_all_datetime = []
            let soil_rain_lv_max_datetime = []
            let soil_rain_risk_max_datetime = []
            let soil_rain_h1_max_datetime = []
            let consts = {}

            let msh_sr_rain_all_data = []
            let area_sr_rain_all_data = []

            let msh_chronology_all_datetime = []
            let chronology_main_damage_num = []
            let chronology_finish_num = []
            let chronology_ongoing_num = []
            let chronology_city_data = []

            let bsn_h1_of_all_datetime = []
            let bsn_h1_of_max = []
            let tel_data_latest = []
            let tel_risk_rank = []

            let msh_road_all_datetime = []
            let road_rank = []

            let city_shelter_all_datetime = []
            let city_evac_level_data_all_datetime = []
            let shelter_analysis_map_data = []

            if (props.selectBsn && Array.isArray(props.selectBsn)
                && props.selectBsn.length > 0) {
                params_obj = getParams(props.selectBsn, 'bsn_code')
            } else if (props.selectTelCode && Array.isArray(props.selectTelCode)
                && props.selectTelCode.length > 0) {
                params_obj = getParams(props.selectTelCode, 'tel_code')
            } else if (props.selectArea && Array.isArray(props.selectArea)
                && props.selectArea.length > 0) {
                params_obj = getParams(props.selectArea, 'area_code')
            } else if (props.selectMsh && Array.isArray(props.selectMsh)
                && props.selectMsh.length > 0) {
                params_obj = getParams(props.selectMsh, 'id')
            } else if (props.selectSubCity && Array.isArray(props.selectSubCity)
                && props.selectSubCity.length > 0) {
                params_obj = getParams(props.selectSubCity, 'city_code')
            } else if (props.selectShelterCode && Array.isArray(props.selectShelterCode)
                && props.selectShelterCode.length > 0) {
                params_obj = getParams(props.selectShelterCode, 'shelter_code')
            } else {
                params_obj = getParams(props.selectCitys, 'city_code')
            }

            if (Object.keys(params_obj).length > 0) {
                // 日時の配列を取得
                date_ary = getTimeAry(datetimeLatest, props.h6Switch)

                //// メッシュコードごとのリスクと雨量のオブジェクト配列を取得
                // [{ code: 503021111（メッシュコード）, 
                // risk_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24], 
                // h1_val: [1, 1, 1, 1, 1, 1, 9, 5, 6, 7],}, ..............]
                //FOR RISK
                msh_landslide_risk_h1_all_datetime = getAllByCode(params_obj.msh_code_ary, mshLandslideData, props.h6Switch)

                if (msh_landslide_risk_h1_all_datetime.length > 0) {
                    //// 字コードごとのリスクと雨量のオブジェクト配列を取得
                    // [{ code: 401010010（字コード）, 
                    // risk_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24], 
                    // h1_val: [1, 1, 1, 1, 1, 1, 9, 5, 6, 7],}, ..............]
                    area_landslide_risk_h1_all_datetime = convertAreaDataFromMshData(params_obj.masterMshFeatures, msh_landslide_risk_h1_all_datetime, params_obj.masterAreaFeatures)
                    area_landslide_risk_h1_all_datetime_msh = convertAreaDataMshData(params_obj.masterMshFeatures, msh_landslide_risk_h1_all_datetime)
                    // 地図の字レイヤー用のデータ
                    area_landslide_risk_h1_max = getRiskH1MaxByCode(area_landslide_risk_h1_all_datetime, 0)
                    // 地図の市町村レイヤー用のデータ
                    city_landslide_risk_h1_max = getRiskH1MaxByCode(area_landslide_risk_h1_all_datetime, 5)
                    // 地図のメッシュレイヤー用のデータ
                    msh_landslide_risk_h1_max = getRiskH1MaxByCode(msh_landslide_risk_h1_all_datetime, 0)

                    // 土砂のリスク最大値用のデータ
                    area_landslide_risk_all_datetime = getAllByDateTimeWithAreaRiskInfo(params_obj.masterAreaFeatures, area_landslide_risk_h1_all_datetime)
                    landslide_risk_rank = getRankWithLimit(area_landslide_risk_all_datetime, 200)
                    landslide_risk_maxVal = landslide_risk_rank[0].max

                    // 複合グラフのbarチャート用のデータ
                    landslide_h1_max_datetime = getMaxByDateTime(area_landslide_risk_h1_all_datetime_msh, 'h1_dc_value_num');

                    // 最大1時間雨量用のデータ
                    landslide_h1_maxVal = Math.max(...landslide_h1_max_datetime.slice(6));

                    // 土壌雨量指数の複合グラフのラインチャート用のデータ
                    if (area_landslide_risk_h1_all_datetime.length > 0) {
                        soil_rain_lv_max_datetime = getMaxByDateTime(area_landslide_risk_h1_all_datetime, 'soil_index_level');
                        soil_rain_risk_max_datetime = getMaxByDateTime(area_landslide_risk_h1_all_datetime, 'dc_tank_of_num');
                    }
                    else {
                        soil_rain_lv_max_datetime = getMaxByDateTime(area_landslide_risk_h1_all_datetime_msh, 'soil_index_level');
                        soil_rain_risk_max_datetime = getMaxByDateTime(area_landslide_risk_h1_all_datetime_msh, 'dc_tank_of_num');
                    }

                    // 小数点を切り上げにして整数にする
                    soil_rain_risk_max_datetime = soil_rain_risk_max_datetime.map(v =>
                        (v === null || v === undefined) ? v : Math.round(v)
                    );
                    // 土壌雨量指数の複合グラフのアノテーション用のデータ
                    const targetAry = msh_landslide_risk_h1_all_datetime.map(item => ({
                        code: item.code,
                        val: item['dc_tank_of_num'],
                        sr_std: getSrRiskLevel(item.code, params_obj.masterMshFeatures)
                    }));

                    // sr_std を集約して POINT を作る（LEVEL_2..LEVEL_5 の各値を最大値で代表させる）
                    // 注意: risk_analysis 側では単一メッシュ選択時にそのメッシュの sr_std を用いるため、
                    // ここでも選択が単一メッシュならそのメッシュの sr_std を優先して使う。
                    let aggregatedPOINT = {};
                    if (params_obj && Array.isArray(params_obj.msh_code_ary) && params_obj.msh_code_ary.length === 1) {
                        // 単一メッシュ選択時: そのメッシュの sr_std を使う（risk_analysis と同様）
                        const selectedMsh = params_obj.msh_code_ary[0];
                        const targetItem = targetAry.find(t => String(t.code) === String(selectedMsh));
                        if (targetItem && targetItem.sr_std) {
                            aggregatedPOINT = { ...targetItem.sr_std };
                        } else {
                            // 見つからなければフォールバックして全体を集約
                            aggregatedPOINT = targetAry.reduce((acc, cur) => {
                                const s = cur.sr_std || {};
                                ['LEVEL_2', 'LEVEL_3', 'LEVEL_4', 'LEVEL_5'].forEach(k => {
                                    const v = s[k];
                                    if (v != null) {
                                        acc[k] = acc[k] == null ? v : Math.max(acc[k], v);
                                    }
                                });
                                return acc;
                            }, {});
                        }
                    } else {
                        // 複数メッシュまたは未選択時: これまでどおり全体を集約
                        aggregatedPOINT = targetAry.reduce((acc, cur) => {
                            const s = cur.sr_std || {};
                            ['LEVEL_2', 'LEVEL_3', 'LEVEL_4', 'LEVEL_5'].forEach(k => {
                                const v = s[k];
                                if (v != null) {
                                    acc[k] = acc[k] == null ? v : Math.max(acc[k], v);
                                }
                            });
                            return acc;
                        }, {});
                    }

                    // もし aggregatedPOINT に何も入っていなければデフォルトで空配列（注釈なし）または既定値を使う
                    if (Object.keys(aggregatedPOINT).length > 0) {
                        consts = getConsts(SR_Y_4LINES, aggregatedPOINT);
                    } else {
                        consts = { bar_or_line_annotations: [], bar_or_line_limit_val: 2000 };
                    }

                    // 複合グラフのbarチャート用のデータ
                    soil_rain_h1_max_datetime = getMaxByDateTime(area_landslide_risk_h1_all_datetime, 'h1_val');
                    // 土壌雨量指数の日時データを整数化
                    soil_rain_h1_max_datetime = soil_rain_h1_max_datetime.map(v =>
                        (v === null || v === undefined) ? v : Math.floor(v)
                    );

                    // ヒートマップ用のデータ
                    city_landslide_risk_h1_all_datetime = convertCityDataFromMshData(params_obj.masterMshFeatures, msh_landslide_risk_h1_all_datetime)
                    landslide_risk_all_datetime = getAllByDateTimeCityInfo(params_obj.masterMshFeatures, city_landslide_risk_h1_all_datetime);
                }

                // 散布図用のデータを取得
                msh_sr_rain_all_data = filterDataByCodeAry(params_obj.msh_code_ary, mshLandslideData)
                area_sr_rain_all_data = convertAreaDataSrRainFromMshData(params_obj.masterMshFeatures, msh_sr_rain_all_data, params_obj.masterAreaFeatures)
                if (area_sr_rain_all_data.length > 0) {
                    // 字ごと（1時間雨量(mm/h)、土壌雨量指数）の散布図データ
                    risk_scatter_all_datetime_area = convertAreaDataScatterFromAreaData(params_obj.masterMshFeatures, area_sr_rain_all_data)
                    // 市町村ごと（1時間雨量(mm/h)、土壌雨量指数）の散布図データ
                    risk_scatter_all_datetime_city = convertCityDataScatterFromAreaData(params_obj.masterMshFeatures, area_sr_rain_all_data)
                }
                else {
                    // 字ごと（1時間雨量(mm/h)、土壌雨量指数）の散布図データ
                    risk_scatter_all_datetime_area = convertAreaDataScatterFromMshData(params_obj.masterMshFeatures, msh_sr_rain_all_data)
                    // 市町村ごと（1時間雨量(mm/h)、土壌雨量指数）の散布図データ
                    risk_scatter_all_datetime_city = convertCityDataRiskFromMshData(params_obj.masterMshFeatures, msh_sr_rain_all_data)
                }

                // FOR CHRONOLOGY
                msh_chronology_all_datetime = getAllByMshCodeChronology(params_obj.msh_code_ary, mshChronologyData, false)
                if (msh_chronology_all_datetime.length > 0) {
                    // 被害情報発生件数用のデータ
                    chronology_main_damage_num = getKeyNameCountByDateTime(msh_chronology_all_datetime, 'int_main_damage_num');
                    // 対処済件数用のデータ
                    chronology_finish_num = getKeyNameCountByDateTime(msh_chronology_all_datetime, 'int_finished_num');
                    // 対処中件数用のデータ
                    chronology_ongoing_num = getKeyNameCountByDateTime(msh_chronology_all_datetime, 'int_ongoing_num');
                    // 市町村ごとの被害情報分析を取得
                    chronology_city_data = getChronologyRankWithLimit(msh_chronology_all_datetime, 200);
                }

                // FOR TEL
                bsn_h1_of_all_datetime = getAllByCode(params_obj.bsn_code_ary, bsnOfData, props.h6Switch)
                // 水位計
                let telArray = getTelIsCurrentVal(params_obj.tel_code_ary, telData)
                if (telArray.length > 0) {
                    tel_data_latest = getMaxListTel(telArray, 0);
                }
                if (bsn_h1_of_all_datetime.length > 0) {
                    // 流域平均1時間雨量を取得
                    bsn_h1_of_max = getMaxH1OfByCode(bsn_h1_of_all_datetime, 0)
                }
                // 水位パーセントランキングを取得
                tel_risk_rank = getRankBsn(params_obj.tel_code_ary, params_obj.masterTelFeatures, telData, 'risk_val', 'pct_val', 200);

                // 道路リスクランキングを取得
                msh_road_all_datetime = getAllByCode(params_obj.msh_code_ary, roadRiskData, props.h6Switch)
                if (msh_road_all_datetime.length > 0) {
                    road_rank = convertRoadDataFromMshData(params_obj.masterMshFeatures, msh_road_all_datetime)
                }

                // 避難所分析を取得
                city_shelter_all_datetime = getAllByShelterCode(params_obj.shelter_code_ary, shelterData)
                city_evac_level_data_all_datetime = getAllByCityCode(params_obj.city_code_ary, shelterEvacLevelCityData, false)
                if (city_shelter_all_datetime.length > 0) {
                    shelter_analysis_map_data = getShelterAnalysisList(city_shelter_all_datetime);
                }
            }

            // 期間最大警報基準相当
            setLandslideRiskMaxVal(landslide_risk_maxVal)
            // 最大1時間雨量
            setLandslideH1MaxVal(landslide_h1_maxVal)

            // 市町境のデータを除外
            // 地図の市町村レイヤー用のデータ (5桁でチェック)
            const filteredCityMax = city_landslide_risk_h1_max.filter(item =>
                props.selectCitys.includes(String(item.code))
            );

            // 地図の字レイヤー用のデータ (上5桁が選択中の市町村かチェック)
            const filteredAreaMax = area_landslide_risk_h1_max.filter(item => {
                const parentCityCode = String(Math.floor(Number(item.code) / 10000)); // 数値→文字列
                return props.selectCitys.includes(parentCityCode);
            });

            // 地図（被災リスク（土砂）予測）
            setCityLandslideRiskH1(filteredCityMax.length > 0 ? filteredCityMax : null)
            setAreaLandslideRiskH1(filteredAreaMax.length > 0 ? filteredAreaMax : null)
            setMshLandslideRiskH1(msh_landslide_risk_h1_max.length > 0 ? msh_landslide_risk_h1_max : null)
            // 地図（クロノロジーデータ）
            setChronologyList(msh_chronology_all_datetime.length > 0 ? msh_chronology_all_datetime : null)

            // 散布図（字名ごとの1時間雨量、土壌雨量指数）
            setRiskScatterAllDatetimeArea(risk_scatter_all_datetime_area?.length > 0 ? risk_scatter_all_datetime_area : null)
            // 散布図（市町村ごとの1時間雨量、土壌雨量指数）
            setRiskScatterAllDatetimeCity(risk_scatter_all_datetime_city?.length > 0 ? risk_scatter_all_datetime_city : null)

            // 複合チャート（土壌雨量指数）
            setSoilRainMaxRiskDatetime(soil_rain_risk_max_datetime.length > 0 ? soil_rain_risk_max_datetime : null)
            setSoilRainMaxLvDatetime(soil_rain_lv_max_datetime.length > 0 ? soil_rain_lv_max_datetime : null)
            // 複合チャート（1時間雨量）
            setLandslideMaxH1Datetime(landslide_h1_max_datetime.length > 0 ? landslide_h1_max_datetime : null)
            // 複合チャートのアノテーション
            setBarOrLineAnnotatios(consts.bar_or_line_annotations)
            setBarOrLineLimitVal(consts.bar_or_line_limit_val)

            // ヒートマップ
            setLandslideAllRiskDatetime(landslide_risk_all_datetime.length > 0 ? landslide_risk_all_datetime : null)

            // 被害情報発生件数
            setMainDamageVal(chronology_main_damage_num)
            // 対処済件数
            setFinishVal(chronology_finish_num)
            // 対処中件数
            setOngoingVal(chronology_ongoing_num)

            // クロノロジー分析
            setChronologyCityData(chronology_city_data.length > 0 ? chronology_city_data : null)

            // 地図（水位と被災リスク（河川）予測）
            setBsnH1Of(bsn_h1_of_max.length > 0 ? bsn_h1_of_max : null)
            setTelDataLatestVal(tel_data_latest.length > 0 ? tel_data_latest : null)
            // ランキング（水位パーセント）
            setTelRiskAllRankData(tel_risk_rank)

            // ランキング（道路リスク）
            setRoadAllRankData(road_rank.length > 0 ? road_rank : null)

            // 避難所分析データ
            setShelterAnalysisData(shelter_analysis_map_data.length > 0 ? shelter_analysis_map_data : null)
            // 避難指示発令地域データ
            setEvacLevelCityData(city_evac_level_data_all_datetime.length > 0 ? city_evac_level_data_all_datetime : null)

            // 日時
            setDateArray(date_ary.length > 0 ? date_ary : null)
        };
        if (datetimeLatest
            && mshLandslideData
            && mshChronologyData
            && telData
            && bsnOfData
            && shelterData
            && shelterEvacLevelCityData
            && roadRiskData
            && riskStatusData
        ) {
            fetchData();
        }
    }, [datetimeLatest,
        mshLandslideData,
        mshChronologyData,
        telData,
        bsnOfData,
        shelterData,
        shelterEvacLevelCityData,
        roadRiskData,
        riskStatusData,
        props.selectCitys, props.selectSubCity, props.selectArea, props.selectMsh,
        props.selectTelCode, props.selectBsn, props.selectShelterCode, props.h6Switch
    ]);

    if (datetimeLatestLoading || datetimeLatest === undefined
        || (datetimeLatestError && datetimeLatestError.message.includes("Receivsed HTML"))
        || mshLandslideLoading || mshLandslideData === undefined
        || (mshLandslideError && mshLandslideError.message.includes("Received HTML"))
        || bsnOfLoading || bsnOfData === undefined
        || (bsnOfError && bsnOfError.message.includes("Received HTML"))
        || telLoading || telData === undefined
        || (telError && telError.message.includes("Received HTML"))
        || shelterLoading || shelterData === undefined
        || (shelterError && shelterError.message.includes("Received HTML"))
        || shelterEvacLevelCityLoading || shelterEvacLevelCityData === undefined
        || (shelterEvacLevelCityError && shelterEvacLevelCityError.message.includes("Received HTML"))
        || bsnOfLoading || bsnOfData === undefined
        || (bsnOfError && bsnOfError.message.includes("Received HTML"))
        || roadRiskLoading || roadRiskData === undefined
        || (roadRiskError && roadRiskError.message.includes("Received HTML"))
        || riskStatusLoading || riskStatusData === undefined
        || (riskStatusError && riskStatusError.message.includes("Received HTML"))
    ) {
        // Loading表示
        return <Proggress />
    }

    if (datetimeLatestError
        || mshLandslideError
        || mshChronologyError
        || telError
        || bsnOfError
        || shelterError
        || shelterEvacLevelCityError
        || roadRiskError
        || riskStatusError
    ) {
        return (
            <Typography
                sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    color: 'white',
                }}
            >
                申し訳ございません、データ取得に失敗しました。<br />
                恐れ入りますが、しばらく時間をおいてから再度お試しください。
            </Typography>
        )
    }

    return (
        <>
            <PageLayout
                riskStatus={riskStatusData[0].status}
                dateTime={datetimeLatest && datetimeLatest[12]}
            >
                <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ order: { xs: 1, sm: 1, md: 0 }, height: { xs: 'auto', sm: '50%' } }}>
                    <Stack spacing={0} sx={{ height: { xs: 'auto', sm: '100%' } }}>
                        {/* リスク・雨量最大値 */}
                        <CommonCard
                            child={
                                <MapRiskMax
                                    selectSubCity={props.selectSubCity}
                                    setSelectSubCity={props.setSelectSubCity}
                                    selectArea={props.selectArea}
                                    setSelectArea={props.setSelectArea}
                                    selectMsh={props.selectMsh}
                                    setSelectMsh={props.setSelectMsh}
                                    selectBsn={props.selectBsn}
                                    setSelectBsn={props.setSelectBsn}
                                    selectCitys={props.selectCitys}
                                    selectLayerList={selectLayerList}
                                    setSelectLayerList={setSelectLayerList}
                                    cityLandslideRiskH1={cityLandslideRiskH1}
                                    areaLandslideRiskH1={areaLandslideRiskH1}
                                    mshLandslideRiskH1={mshLandslideRiskH1}
                                    chronologyList={chronologyList}
                                    riskMapZoom={props.riskMapZoom}
                                    riskMapCenter={props.riskMapCenter}
                                    selectLayer={selectLayer}
                                    setSelectLayer={setSelectLayer}
                                    setRiskColor={(risk) => setMapRiskColor(SOIL_RISK_COLOR, risk)}
                                    shouldClearSelect={shouldClearSelect}
                                    setShouldClearSelect={setShouldClearSelect}
                                    tooltipLabel={"警報基準相当"}
                                    legendLabel={"警報基準相当"}
                                    pageType={'summary'}
                                />
                            }
                            title={"警報基準相当"}
                            xsHeight="300px"
                        // 「18px」ヘッダー、「9px」時刻表示の半分、
                        // 「8px」ページ全体のパディング分、「31px」タイトル分
                        // handleReset={handleAreaReset}
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 2 }} sx={{ order: { xs: 2, sm: 2, md: 0 }, height: { xs: 'auto', sm: '50%' } }}>
                    <Stack spacing={0} sx={{ height: { xs: 'auto', sm: '100%' } }}>
                        {/* 期間最大警報基準相当・最大1時間雨量 */}
                        <MaxRiskH1Txt
                            titleRisk={"期間最大警報基準相当"}
                            titleH1={"最大1時間雨量"}
                            riskMaxVal={landslideRiskMaxVal}
                            h1MaxVal={landslideH1MaxVal}
                            setColor={setSrColor}
                            setFontSize={setSrFontSize}
                            setLabel={setSrRiskLabel}
                            levelPoint={SR_RISK_LEVEL_POINT}
                        />
                        {/* 福岡県災害対策本部設置基準 */}
                        <CommonCard
                            child={
                                <>
                                    <ScatterRisk
                                        distance={riskScatterAllDatetimeArea?.length}
                                        scatterData={riskScatterAllDatetimeArea}
                                        getSeries={soilRainGetSeriesH1DcTank}
                                        x_ary={soil_rain_dc_tank_ary}
                                        y_ary={soil_rain_h1_ary}
                                        maxValX={200}
                                        maxValY={30}
                                        isShowLabelMaxXMm={false}
                                        scatterClickEvent={scatterClickEvent}
                                        setTooltipInfo={setTooltipInfoScatterRisk}
                                        tooltipInfo={tooltipInfoScatterRisk}
                                        renderBody={renderTooltipBody}
                                        isReadyKey={['scatter_rain_h1_dc_tank']}
                                        isReadyFlg={props.isReady.scatter_rain_h1_dc_tank}
                                        setReady={props.setReady}
                                        selectCitys={props.selectCitys}
                                        isShowDataLabel={false}
                                        height={'100%'}
                                        textX={"土壌雨量指数"}
                                        textY={"1時間雨量"}
                                        whiteSpace={'normal'}
                                        tooltipKey={"scatter_rain_h1_dc_tank"}
                                    />
                                </>
                            }
                            title={"字名ごとの1時間雨量, 土壌雨量指数"}
                            xsHeight="200px"
                        />
                        {/* 市町村ごとの1時間雨量、累加雨量 */}
                        <CommonCard
                            child={
                                <>
                                    <ScatterRisk
                                        distance={riskScatterAllDatetimeCity?.length}
                                        scatterData={riskScatterAllDatetimeCity}
                                        getSeries={soilRainGetSeriesH1DcTankCity}
                                        x_ary={soil_rain_dc_tank_ary}
                                        y_ary={soil_rain_h1_ary}
                                        maxValX={200}
                                        maxValY={30}
                                        isShowLabelMaxXMm={false}
                                        scatterClickEvent={scatterClickEvent}
                                        setTooltipInfo={setTooltipInfoScatterRisk}
                                        tooltipInfo={tooltipInfoScatterRisk}
                                        renderBody={renderTooltipBody}
                                        isReadyKey={['scatter_rain_h1_dc_tank_city']}
                                        isReadyFlg={props.isReady.scatter_rain_h1_dc_tank_city}
                                        setReady={props.setReady}
                                        selectCitys={props.selectCitys}
                                        isShowDataLabel={true}
                                        height={'100%'}
                                        textX={"土壌雨量指数"}
                                        textY={"1時間雨量"}
                                        whiteSpace={'normal'}
                                        tooltipKey={"scatter_rain_h1_dc_tank_city"}
                                    />
                                </>
                            }
                            title={"市町村ごとの1時間雨量, 土壌雨量指数"}
                            xsHeight="200px"
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 5 }} sx={{ order: { xs: 3, sm: 3, md: 0 }, height: { xs: 'auto', sm: '50%' } }}>
                    <Stack spacing={0} sx={{ height: { xs: 'auto', sm: '100%' } }}>
                        {/* 期間内1時間雨量、土壌雨量指数 */}
                        <CommonCard
                            child={
                                <BarLine
                                    annotations={barOrLineAnnotatios}
                                    limitVal={barOrLineLimitVal}
                                    dateArray={dateArray}
                                    xDatetime={soilRainMaxRiskDatetime}
                                    yDatetime={landslideMaxH1Datetime}
                                    xDatetime2={soilRainMaxLvDatetime}
                                    getPoints={getPoints}
                                    getBarColor={getBarColorH1Rain}
                                    getTooltipMarkerColor={getTooltipMarkerColorSoilRain}
                                    seriesNameX={'土壌雨量指数'}
                                    seriesNameY={'1時間雨量'}
                                    colors={['#5c9fed', '#5c9fed']}
                                    strokeColors={['#5c9fed', 'transparent']}
                                    shared={true}
                                    intersect={false}
                                    format={format}
                                    bottom={-30}
                                    height={'calc(100%)'}
                                    isReadyKey={['bar_line_soil']}
                                    isReadyFlg={props.isReady.bar_line_soil}
                                    setReady={props.setReady}
                                    chooseNum={12}
                                />
                            }
                            title={"期間内1時間雨量, 土壌雨量指数"}
                            xsHeight="200px"
                        />
                        {/* ヒートマップ */}
                        <CommonCard
                            child={
                                <HeatmapRisk
                                    distance={6}
                                    limitDataCount={200}
                                    dateArray={datetimeLatest}
                                    allRiskDatetime={landslideAllRiskDatetime}
                                    getHeatmapData={getHeatmapRiskData}
                                    heatmapClickEvent={heatmapClickEvent}
                                    colorScale={colorScaleRisk}
                                    setTooltipInfo={setTooltipInfoScatterRisk}
                                    tooltipInfo={tooltipInfoScatterRisk}
                                    renderBody={renderTooltipBody}
                                    tooltipKey={"heatmap_rain_city"}
                                    isReadyKey={['heatmap_rain_city']}
                                    isReadyFlg={props.isReady.heatmap_rain_city}
                                    setReady={props.setReady}
                                    isShowLegend={false}
                                />
                            }
                            title={"市町村名, 日時ごとの警報基準相当"}
                            xsHeight="200px"
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 2 }} sx={{ order: { xs: 6, sm: 6, md: 0 }, height: { xs: 'auto', sm: '50%' } }}>
                    {/* クロノロジー発生件数、対処済件数、対処中件数、クロノロジー分析 */}
                    <Stack spacing={0} sx={{ height: { xs: 'auto', sm: '100%' } }}>
                        <DamageIncidents
                            titleDamageIncidents={"クロノロジー発生件数"}
                            titleResolved={"対処済件数"}
                            titleInProgress={"対処中件数"}
                            mainDamageVal={mainDamageVal}
                            finishVal={finishVal}
                            ongoingVal={ongoingVal}
                            isPageSummary={true}
                        />
                        <CommonCard
                            child={
                                <VerticalBarStack
                                    distance={100}
                                    limitVal={0}
                                    grid={GRID_RANK}
                                    allRankData={chronologyCityData}
                                    dateArray={dateArray}
                                    getRankData={getRankDataChronology}
                                    plusValue={1}
                                    verticalBarClickEvent={verticalBarChronologyClickEvent}
                                    getRankColor={getRankColorChronology}
                                    fontSize={'12px'}
                                    maxWidth={100}
                                    getLabelFormat={getChrLabelFormat}
                                    enabled={true}
                                    tooltipFormatX={tooltipFormatX}
                                    tooltipFormatY={tooltipFormatY}
                                    tooltipFormatCustom={tooltipFormatCustom}
                                    height={'100%'}
                                    isReadyKey={['vertical_bar_chronology']}
                                    isReadyFlg={props.isReady.vertical_bar_chronology}
                                    setReady={props.setReady}
                                    isPageSummary={true}
                                />
                            }
                            title={"クロノロジー分析"}
                            xsHeight="300px"
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ order: { xs: 4, sm: 4, md: 0 }, height: { xs: 'auto', sm: '50%' } }}>
                    {/* 水位と被災リスク（河川）予測 */}
                    <Stack spacing={0} sx={{ height: { xs: 'auto', sm: '100%' } }}>
                        <CommonCard
                            child={
                                <MapBsnTelAverage
                                    selectTelCode={props.selectTelCode}
                                    setSelectTelCode={props.setSelectTelCode}
                                    selectBsn={props.selectBsn}
                                    setSelectBsn={props.setSelectBsn}
                                    selectMsh={props.selectMsh}
                                    setSelectMsh={props.setSelectMsh}
                                    selectCitys={props.selectCitys}
                                    bsnData={bsnH1Of}
                                    telData={telDataLatestVal}
                                    bsnMapZoom={props.bsnMapZoom}
                                    bsnMapCenter={props.bsnMapCenter}
                                    label={'流域平均流出量'}
                                />
                            }
                            title={"河川水位計と流出量変化"}
                            xsHeight="300px"
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ order: { xs: 5, sm: 5, md: 0 }, height: { xs: 'auto', sm: '50%' } }}>
                    {/* 水位パーセントランキング */}
                    <Stack spacing={0} sx={{ height: { xs: 'auto', sm: '100%' } }}>
                        <CommonCard
                            child={
                                <VerticalBar
                                    distance={20}
                                    limitVal={100}
                                    grid={GRID_RANK}
                                    allRankData={telRiskAllRankData}
                                    dateArray={dateArray}
                                    getRankData={getRankDataRiver}
                                    plusValue={10}
                                    verticalBarClickEvent={verticalBarClickEventRiver}
                                    getRankColor={getRankColorRiver}
                                    fontSize={'12px'}
                                    getFormat={getFormatRiver}
                                    maxWidth={180}
                                    getLabelFormat={getLabelFormat}
                                    enabled={true}
                                    tooltipFormatX={tooltipFormatXRiver}
                                    tooltipFormatY={tooltipFormatY}
                                    tooltipFormatCustom={tooltipFormatCustomRiver}
                                    height={'100%'}
                                    isReadyKey={['rank_river']}
                                    isReadyFlg={props.isReady.rank_river}
                                    setReady={props.setReady}
                                />
                            }
                            title={"水位パーセントランキング"}
                            xsHeight="300px"
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ order: { xs: 7, sm: 7, md: 0 }, height: { xs: 'auto', sm: '50%' } }}>
                    <Stack spacing={0} sx={{ height: { xs: 'auto', sm: '100%' } }}>
                        {/* 道路リスクランキング */}
                        <CommonCard
                            child={
                                <VerticalBar
                                    distance={15}
                                    limitVal={100}
                                    grid={GRID_RANK}
                                    allRankData={roadAllRankData}
                                    dateArray={dateArray}
                                    getRankData={getRankDataRoad}
                                    plusValue={10}
                                    verticalBarClickEvent={verticalBarClickEventRoad}
                                    getRankColor={getRankColorRoad}
                                    fontSize={'12px'}
                                    getFormat={getFormatRoad}
                                    maxWidth={180}
                                    getLabelFormat={getLabelFormat}
                                    enabled={true}
                                    tooltipFormatX={tooltipFormatXRiver}
                                    tooltipFormatY={tooltipFormatY}
                                    tooltipFormatCustom={tooltipFormatCustomRiver}
                                    height={'100%'}
                                    isReadyKey={['rank_road_risk']}
                                    isReadyFlg={props.isReady.rank_road_risk}
                                    setReady={props.setReady}
                                />
                            }
                            title={"道路リスクランキング"}
                            xsHeight="300px"
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3 }} sx={{ order: { xs: 8, sm: 8, md: 0 }, height: { xs: 'auto', sm: '50%' } }}>
                    <Stack spacing={0} sx={{ height: { xs: 'auto', sm: '100%' } }}>
                        {/* 避難所と避難指示発令地域 */}
                        <CommonCard
                            child={
                                <MapShelterAnalysis
                                    selectCitys={props.selectCitys}
                                    setSelectSubCity={props.setSelectSubCity}
                                    setSelectShelterCode={props.setSelectShelterCode}
                                    riskMapZoom={props.riskMapZoom}
                                    riskMapCenter={props.riskMapCenter}
                                    shelterList={shelterAnalysisData}
                                    shelterEvacLevelCityList={evacLevelCityData}
                                    shelterNeedInspectionList={[]}
                                />
                            }
                            title={"避難所と避難指示発令地域"}
                            xsHeight="300px"
                        />
                    </Stack>
                </Grid>
            </PageLayout>
        </>
    )
}

export default Summary;